import Vue from 'vue'
import VueRouter from 'vue-router'
import routes from './routes'
Vue.use(VueRouter)

const router = new VueRouter({
  base: process.env.VUE_APP_BASE_CONTEXT,
  routes: routes,
  // mode: 'history',
})

// TBD 鉴权加在这
router.beforeEach(async (to, from, next) => {
  next();
})
export default router
